// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"EntityTask_progressBar__2qWEz","listItem":"EntityTask_listItem__3itzu","lineThrough":"EntityTask_lineThrough__2KLlf","detail":"EntityTask_detail__3p93q"};